import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
function StarRating() {
  return <div className="flex items-center gap-1 mb-5" aria-label="5 de 5 estrellas" data-id="element-87">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-88" />)}
    </div>;
}
export function ExtendedTestimonials() {
  const testimonials = [{
    initials: 'MP',
    name: 'Marcos P.',
    location: 'Buenos Aires 🇦🇷',
    role: 'Entrenador de Club de Barrio',
    quote: 'Compré un sábado. El domingo a la noche tenía el mes de clases listo. Nunca más improviso.'
  }, {
    initials: 'CG',
    name: 'Carolina G.',
    location: 'Córdoba 🇦🇷',
    role: 'Entrenadora en Club Privado',
    quote: 'Tres nenas de 9na que estaban estancadas mejoraron el push en el primer mes con el Tomo 3.'
  }, {
    initials: 'FR',
    name: 'Fernando R.',
    location: 'Rosario 🇦🇷',
    role: 'Entrenador Independiente',
    quote: 'Antes tardaba 1 hora armando la clase. Ahora son 5 minutos. No lo puedo creer.'
  }, {
    initials: 'SV',
    name: 'Sofía V.',
    location: 'Mendoza 🇦🇷',
    role: 'Entrenadora de Club Federado',
    quote: 'El Nivelómetro cambió cómo armo mis equipos A y B. Ahora tengo un criterio real para decidir y justificarlo.'
  }, {
    initials: 'DA',
    name: 'Diego A.',
    location: 'Santa Fe 🇦🇷',
    role: 'Profe de Educación Física',
    quote: 'Los Sistemas Olímpicos me salvaron en la semifinal. Usé el Falso Arriba y el rival no supo cómo defendernos.'
  }, {
    initials: 'LR',
    name: 'Laura R.',
    location: 'Tucumán 🇦🇷',
    role: 'Entrenadora de Mayores',
    quote: 'El Acelerador Técnico cambió mis clases. Nunca más el mismo ejercicio dos veces. El grupo se nota motivado.'
  }];
  return <section className="bg-white py-20 px-4" data-id="element-89">
      <div className="max-w-6xl mx-auto" data-id="element-90">
        <div className="text-center mb-16" data-id="element-91">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block bg-[#F97316] text-white font-bold px-6 py-2 rounded-full text-xl mb-6 shadow-sm" data-id="element-92">
            4.9/5 ⭐
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-bold text-[#0284C7] uppercase tracking-wide" data-id="element-93">
            Lo que dicen los entrenadores
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-94">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-8 rounded-2xl border-2 border-[#0284C7]/10 hover:border-[#0284C7]/30 transition-colors shadow-sm flex flex-col" data-id="element-95">
              <StarRating data-id="element-96" />
              <div className="flex items-center gap-4 mb-6" data-id="element-97">
                <div className="w-14 h-14 bg-[#0284C7] text-white rounded-full flex items-center justify-center text-xl font-bold flex-shrink-0" data-id="element-98">
                  {t.initials}
                </div>
                <div data-id="element-99">
                  <p className="font-bold text-gray-900 text-lg" data-id="element-100">{t.name}</p>
                  <p className="text-sm text-gray-600" data-id="element-101">{t.location}</p>
                  <p className="text-xs text-[#0284C7] font-medium mt-1" data-id="element-102">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-gray-700 italic text-lg leading-relaxed flex-grow" data-id="element-103">
                "{t.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}